export function calculatePricePerInterval(prices, count = 1, interval, returnOnlyPrice = false) {
    let price = 0;
    let priceObj = {};
    let price_id = '';

    if (!prices || prices.length === 0) {
        return { price, price_id };
    }

    if (interval === 'monthly') {
        priceObj = prices?.find(
            (item) => item.recurring?.interval === 'month' && item.recurring?.interval_count === 1,
        );
    } else if (interval === 'quarterly') {
        priceObj = prices?.find(
            (item) => item.recurring?.interval === 'month' && item.recurring?.interval_count === 3,
        );
    } else if (interval === 'annualy') {
        priceObj = prices?.find(
            (item) => item.recurring?.interval === 'year' && item.recurring?.interval_count === 1,
        );
    }

    if (priceObj?.billing_scheme === 'tiered') {
        const tier = priceObj.tiers?.find((tier) => count <= tier.up_to || !tier.up_to);
        if (tier) {
            if (returnOnlyPrice) return { price: tier.unit_amount / 100 };
            price += (count * tier.unit_amount) / 100;
        }
    } else if (priceObj?.billing_scheme === 'per_unit') {
        if (returnOnlyPrice) return { price: priceObj.unit_amount / 100 };
        price += (count * priceObj.unit_amount) / 100;
    }
    return { price, price_id: priceObj?.id || '' };
}
